export default function($) {
  $(document).on('click', '.campaign-map-toggle-map', function() {
    $('.campaigns').hide();
    $('.campaign-map__wrap').show();
  });

  $(document).on('click', '.campaign-map-toggle-list', function() {
    $('.campaigns').show();
    $('.campaign-map__wrap').hide();
  });
}
